import { LayoutPanel } from './../../../../../shared/sdk/models/LayoutPanel';
import { ConfirmationService } from 'primeng/primeng';
import { CategoryRotationApi } from './../../../../../shared/sdk/services/custom/CategoryRotation';
import { RotationItemApi } from './../../../../../shared/sdk/services/custom/RotationItem';
import { RotationItem } from './../../../../../shared/sdk/models/RotationItem';
import { CategoryRotation } from './../../../../../shared/sdk/models/CategoryRotation';
import { LoggerService } from './../../../../../shared/sdk/services/custom/logger.service';
import { DataService } from './../../../../../core.module/services/data.service';
import { ScreenCategoryApi } from './../../../../../shared/sdk/services/custom/ScreenCategory';
import { ScreenCategory } from './../../../../../shared/sdk/models/ScreenCategory';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Screen } from '../../../../../shared/sdk';
import { AdvancedCondition } from './advanced-condition.interface';
import * as _ from 'lodash';
import { AvaiableConditions } from './avaiable-conditions';
import * as uuidv4 from 'uuid/v4';

@Component({
  selector: 'app-editconditions-dialog',
  templateUrl: './editconditions-dialog.component.html',
  styleUrls: ['./editconditions-dialog.component.css']
})
export class EditConditionDialogComponent implements OnInit {

  public conditionsList: AdvancedCondition[] = [];
  public currentCondition: AdvancedCondition;
  public hasChange: boolean;
  public loadingConditions: boolean;


  // dropdowns
  public avaiableConditions = new AvaiableConditions();
  public currentTarget;
  public currentType;
  public currentField;
  public currentOperation;
  public currentValue;

  public targets = [];
  public types = [];
  public fields = [];

  @Input() rotationItem: RotationItem;
  @Input() uploadChanges: Boolean = true;

  @ViewChild('valueInput') valueInput;


  public visibleVal: boolean;
  @Output() visibleChange = new EventEmitter();
  @Input()
  get visible() {
    return this.visibleVal;
  }

  set visible(val) {
    if (val) {
      // load data on first showing
      this.currentTarget = null;
      this.currentType = null;
      this.currentField = null;
      this.loadConditions();
    }

    this.visibleVal = val;
    this.visibleChange.emit(this.visibleVal);
  }
  @Output() change = new EventEmitter();



  constructor(
    public screenCategoryApi: ScreenCategoryApi,
    public dataService: DataService,
    public logger: LoggerService,
    public rotationItemApi: RotationItemApi,
    public categoryRotationApi: CategoryRotationApi,
    public confirmationService: ConfirmationService
  ) { }

  async ngOnInit() {

  }

  async loadConditions() {
    this.targets = [];
    for (const target of this.avaiableConditions.data) {
      this.targets.push(target.targetName);
    }
    this.conditionsList = _.clone(this.rotationItem.conditions);
  }


  async saveConditions() {
    this.loadingConditions = true;

    this.rotationItem.conditions = this.conditionsList;

    try {
      await this.rotationItemApi.patchAttributes(this.rotationItem.id, this.rotationItem).toPromise();
    } catch (error) {
      this.logger.error(`Could not save rotation item with new AdvancedCondition`);
    }

    this.loadingConditions = false;
    this.visible = false;
  }


  async keyDownNewConditionName(event) {
    if (event.keyCode === 13 && this.valueInput.nativeElement.value) {
      await this.createNewCondition();
    }
  }

  async createNewCondition() {
    const myId = this.dataService.getCalculatedUserId();
    if (!this.currentOperation) {
      this.currentOperation = 'eq';
    }
    const op = this.avaiableConditions.operations.find(item => { return item.value === this.currentOperation; });
    const opLabel = op ? op.label : '';

    // create group mapped to this user - No rotaions - no players
    const ac: AdvancedCondition = {
      id: uuidv4(), // unique id for this condition
      name: '', // friendly name of this rule

      target: this.currentTarget, // Object to get data from... e.g. currentPlayer
      path: this.currentField.path, // path to data on object eg. weather.today.high.
      operation: this.currentOperation, // gt, lt, eq, ne, contains

      targetName: this.currentTarget.targetName, // Object to get data from... e.g. Player
      typeName: this.currentType.typeName, // friendly name of path section e.g. Weather
      fieldName: this.currentField.fieldName, // friendly name of path field e.g. Todays High
      operationName: opLabel,  // friendly name of operation

      value: this.currentValue, // value to apply operation to
      valueType: this.currentField.valueType, // type of value accepted
      valueLabel: this.currentField.valueLabel // label to put after the value box
    };

    try {
      if (!this.rotationItem.conditions) {
        this.rotationItem.conditions = [];
      }

      this.rotationItem.conditions.push(ac);
      if (this.uploadChanges) {
        const result = await this.rotationItemApi.patchAttributes(this.rotationItem.id, this.rotationItem).toPromise();
      }

      this.valueInput.nativeElement.value = '';
      this.loadConditions();
      this.hasChange = true;
    } catch (error) {
      this.logger.error(`Error saving new condition to rotation item: `, error);
    }

  }

  async deleteConditionConfirm(condition: AdvancedCondition) {
    // don't allow deleting the last rotation

    this.confirmationService.confirm({
      header: `Delete Condition '${condition.name}'?`,
      key: 'deleteRotation',
      icon: 'fa fa-trash',
      message: `Are you sure you want to delete the Condition '<strong>${condition.name}</strong>'?
                          <p>This will remove this category from all rotations and all players.</p>
                          <p><strong>This action cannot be undone</strong></p>`,
      accept: async () => {

        await this.deleteCondition(condition);

      }
    });


  }

  async deleteCondition(condition: AdvancedCondition) {
    // show confirm dialog?
    try {
      this.loadingConditions = true;

      if (!this.rotationItem.conditions) {
        this.rotationItem.conditions = [];
      }

      // remove from local list
      const ac = this.rotationItem.conditions.find(item => { return item.id === condition.id; });
      const index = this.rotationItem.conditions.indexOf(ac);

      if (index > -1) {
        this.rotationItem.conditions.splice(index, 1);
      }

      if (this.uploadChanges) {
        const result = await this.rotationItemApi.patchAttributes(this.rotationItem.id, this.rotationItem).toPromise();
      }


      this.loadConditions(); // load the new conditions into cache

      this.hasChange = true; // tell listners we need a refresh

    } catch (error) {
      this.logger.error(`Error deleting screen category: `, error);
    } finally {
      this.loadingConditions = false;
    }
  }



  move(arr, old_index, new_index) {
    if (new_index >= arr.length) {
      let k = new_index - arr.length;
      while ((k--) + 1) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; // for testing purposes
  }




  checkForChangeOnHide() {
    if (this.hasChange) {
      this.change.emit();
      this.hasChange = false;
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/backend-main.module/pages/scheduling/components/editconditions-dialog/editconditions-dialog.component.ts